<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import {
  first,
  isEnabled,
  payloadOf,
  textOf,
} from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const items = computed(() => {
  const payload = payloadOf(props.event);
  const engineering = first(payload.engenharia);
  const empty = t('POST_SALE.COMMON.EMPTY_VALUE');

  return [
    {
      label: t('POST_SALE.STATUS_DETAILS.FINANCIAL_INSTITUTION'),
      value: textOf(
        engineering.nome_banco || engineering.banco || payload.banco,
        empty,
        t
      ),
    },
    {
      label: t('POST_SALE.STATUS_DETAILS.DAY'),
      value: textOf(
        engineering.data_engenharia || payload.data_engenharia,
        empty,
        t
      ),
    },
    {
      label: t('POST_SALE.STATUS_DETAILS.TIME'),
      value: textOf(
        engineering.hora_engenharia || payload.hora_engenharia,
        empty,
        t
      ),
    },
    {
      label: t('POST_SALE.STATUS_DETAILS.ENGINEERING_REPORT'),
      value: isEnabled(engineering.check_engenharia ?? payload.check_engenharia)
        ? t('POST_SALE.STATUS_DETAILS.INFORMED')
        : t('POST_SALE.STATUS_DETAILS.NOT_INFORMED'),
    },
  ];
});
</script>

<template>
  <PostSaleStatusDetailSection
    :title="t('POST_SALE.STATUS_DETAILS.ENGINEERING')"
    :items="items"
  />
</template>
